import { fonts } from '~/src/helpers/font';
import { EElementType, ILandingElement } from '~/src/services/projects';

export const Header2: ILandingElement = {
    title: 'Header2',
    type: EElementType.Block,
    label: 'Верхний блок с формой',
    properties: {
        blockName: '',
        customStyles: '',
        sortOrder: '',
        background: '',
        backgroundWebp: '',
        marginTop: '',
        marginBottom: '',
        imagePlacement: {},
        isAutoHeightSize: false,
        isVertical: false,
    },
    children: [
        {
            title: 'CitySelect',
            type: EElementType.TextWithoutContent,
            label: 'Выбор города',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#1A1A1A',
                    textAlign: 'left',
                },
                iconColor: 'black',
                customStyles: '',
            },
        },
        {
            title: 'Phone',
            type: EElementType.TextWithoutContent,
            label: 'Телефон',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#1A1A1A',
                    textAlign: 'left',
                },
                customStyles: '',
            },
        },
        {
            title: 'SubTitle',
            type: EElementType.Text,
            label: 'Подзаголовок',
            properties: {
                customize: {
                    font: fonts.XXL,
                    color: '#1A1A1A',
                    textAlign: 'left',
                    tag: '',
                },
                content: 'Подзаголовок',
                customStyles: '',
            },
        },
        {
            title: 'Title',
            type: EElementType.Text,
            label: 'Заголовок',
            properties: {
                customize: {
                    font: fonts.H1,
                    color: '#1A1A1A',
                    textAlign: 'left',
                    tag: '',
                },
                content: 'Заголовок',
                customStyles: '',
            },
        },
        {
            title: 'Text',
            type: EElementType.RTE,
            label: 'Описание',
            properties: {
                customize: {
                    font: fonts.L,
                    color: '#1A1A1A',
                    textAlign: 'left',
                },
                htmlContent: '<p>Текст...</p>',
                customStyles: '',
            },
        },
        {
            title: 'PhoneForm',
            type: EElementType.PhoneForm,
            label: 'Форма',
            properties: {
                customize: {
                    globalEnsId: '',
                },
                phonePlaceholder: 'Номер телефона',
                customStyles: '',
                isBottomSticky: false,
            },
            children: [{
                title: 'Button',
                type: EElementType.Button,
                label: 'Кнопка',
                properties: {
                    customStyles: '',
                },
                children: [
                    {
                        title: 'Text',
                        type: EElementType.Text,
                        label: 'Текст',
                        properties: {
                            customize: {
                                font: fonts.Medium,
                                color: '#FFF',
                                href: '',
                            },
                            content: 'Купить',
                            customStyles: '',
                        },
                    },
                ],
            }],
        },
        {
            title: 'Button',
            type: EElementType.Button,
            label: 'Кнопка',
            properties: {
                customStyles: '',
                isTargetBlank: false,
            },
            children: [
                {
                    title: 'Text',
                    type: EElementType.Text,
                    label: 'Текст',
                    properties: {
                        customize: {
                            font: fonts.Medium,
                            color: '#FFF',
                            href: '',
                        },
                        content: '',
                        customStyles: '',
                    },
                },
            ],
        },
        {
            title: 'Image',
            type: EElementType.Image,
            label: 'Изображение',
            properties: {
                content: '',
                webp: '',
                alt: '',
                customStyles: '',
                offsetX: '',
                offsetY: '',
                customize: {
                    width: '40%',
                },
            },
        },
        {
            title: 'AgeRestriction',
            type: EElementType.AgeRestriction,
            label: 'Возрастные ограничения',
            properties: {
                backgroundColor: '#000',
                customStyles: '',
            },
            children: [
                {
                    title: 'Image',
                    type: EElementType.Image,
                    label: 'Изображение',
                    properties: {
                        content: '',
                        webp: '',
                        alt: '',
                        customStyles: '',
                        customize: {
                            width: '30px',
                            height: '30px',
                        },
                    },
                },
            ],
        },
    ],
};
